import type { JwtPayload, UserRole } from "../types/auth";

export const hasRole = (user: JwtPayload | null | undefined, role: UserRole): boolean =>
  Boolean(user?.roles?.includes(role));

export const isAdmin = (user: JwtPayload | null | undefined): boolean => hasRole(user, "ADMIN");
